import { FC } from 'react';

const ActionCardContractIcon: FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="21" viewBox="0 0 19 21" fill="none">
      <path
        d="M8.8755 6.5H4.89453"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.866 9.5H4.89453"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="6.38739"
        cy="14"
        rx="1.49286"
        ry="1.5"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8331 7.0093V16.5C17.8331 18.1569 16.4964 19.5 14.8474 19.5H3.89978C2.25081 19.5 0.914062 18.1569 0.914062 16.5V4.5C0.914062 2.84315 2.25081 1.5 3.89978 1.5H12.35C13.1419 1.5 13.9013 1.81607 14.4613 2.37868L16.9586 4.888C17.5185 5.4506 17.8331 6.21366 17.8331 7.0093Z"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8332 7H14.3499C13.2505 7 12.3594 6.10457 12.3594 5V1.5"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ActionCardContractIcon;
